import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['confirm', 'loading']

  showLoading() {
    this.confirmTarget.hidden = true
    this.loadingTarget.hidden = false
    this.element.setAttribute('aria-busy', 'true')
  }
}
